module.exports = __webpack_public_path__ + "img/zone.9828e423.svg";